module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921112649_T.cedf12c0.jpg";